import React, { Component } from 'react'
import axios from 'axios';

import {RegisterForm} from '../templates';
import {PageTemplate} from '../atoms';

class RegisterPage extends Component {
  onSubmit = (uuid, email, language, password, firstName, lastName, birthYears, radioGroup) => {
    const {history} = this.props;
    const payload = {
      uuid,
      invitee_email: email,
      password,
      first_name: firstName,
      last_name: lastName,
      sex: radioGroup
    };
    // The birth year dropdown yields a number when picked and an empty string
    // when left blank. Send it as a string when set and omit it entirely when
    // blank, so the server never has to decode a bare number or empty string.
    if (birthYears) {
      payload.birth_years = String(birthYears);
    }
    axios.post(`${process.env.SERVER_URL}/sign-up`, payload)
      .then(() => {
        history.push({pathname: '/accepted', state: {language}});
      }).catch(() => {
        history.push({pathname: '/404', state: {language}});
      });
  };

  render() {
    const {history} = this.props;
    const {onSubmit} = this;
    const {uuid, email, language} = history.location.state;

    return (
      <PageTemplate>
        <RegisterForm uuid={uuid} email={email} language={language} submit={onSubmit} />
      </PageTemplate>
    )
  }
}

export default RegisterPage;